// Sofort sichtbarer Tooltip für Knöpfe mit title (der Browser-Tooltip kommt spät und in Safari oft gar nicht).
// Der title wandert beim Überfahren nach data-tip, damit nicht zusätzlich der Browser-Tooltip erscheint.
const AUSWAHL = 'button[title], button[data-tip], .btn[title], .btn[data-tip]';

export function tooltipsEinrichten() {
  if (!window.matchMedia?.('(hover: hover)').matches) return;
  const blase = document.createElement('div');
  blase.className = 'tip';
  blase.setAttribute('role', 'tooltip');
  let ziel: HTMLElement | null = null;
  let timer = 0;

  const weg = () => {
    window.clearTimeout(timer);
    ziel = null;
    blase.remove();
  };
  const zeigen = (el: HTMLElement) => {
    const text = el.dataset.tip;
    if (!text || !el.isConnected) return;
    // Erste Zeile als Überschrift, wenn eine Beschreibung folgt
    const [kopf, ...rest] = text.split('\n');
    blase.replaceChildren();
    if (rest.length) {
      const b = document.createElement('b');
      b.textContent = kopf;
      blase.append(b, ...rest.map((z) => Object.assign(document.createElement('div'), { textContent: z })));
    } else blase.textContent = kopf;
    document.body.appendChild(blase);
    const r = el.getBoundingClientRect();
    const b = blase.getBoundingClientRect();
    // unter dem Knopf, sonst darüber; waagerecht im Fenster halten
    const unten = r.bottom + 6 + b.height <= window.innerHeight - 4;
    const top = unten ? r.bottom + 6 : r.top - 6 - b.height;
    const left = Math.max(4, Math.min(window.innerWidth - b.width - 4, r.left + r.width / 2 - b.width / 2));
    blase.style.top = `${Math.round(top)}px`;
    blase.style.left = `${Math.round(left)}px`;
  };

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const el = (e.target as Element).closest?.(AUSWAHL) as HTMLElement | null;
    if (el === ziel) return;
    weg();
    if (!el) return;
    const t = el.getAttribute('title');
    if (t) {
      el.dataset.tip = t;
      el.removeAttribute('title');
      // Reine Symbolknöpfe: der title war auch ihr Name für Screenreader
      if (!el.getAttribute('aria-label') && !el.textContent?.trim()) el.setAttribute('aria-label', t.split('\n')[0]);
    }
    if (!el.dataset.tip) return;
    ziel = el;
    timer = window.setTimeout(() => zeigen(el), 250);
  });
  document.addEventListener('pointerout', (e) => {
    if (ziel && !ziel.contains(e.relatedTarget as Node | null)) weg();
  });
  for (const ev of ['pointerdown', 'scroll', 'keydown', 'blur'] as const) window.addEventListener(ev, weg, true);
}
